import { FC } from 'react';

import { Col, FormGroup, Label } from 'reactstrap';

import classNames from 'classnames';

import { Else, If, Then } from '@hsp/react-component-library';

import { Alert } from '@c/alerts';

import { s } from 'utilities';

import { EndDate, StartDate } from './components';
import { useGiftAmountConfiguration } from './hooks';

const GiftAmount: FC = () => {
  const { displayValue, readOnly, isActive, datesChanged } = useGiftAmountConfiguration();

  return (
    <>
      <FormGroup
        className="d-flex"
        row>
        <Label sm={4}>{s(['Site.Total', 'Site.Pages.AudienceBuilder.Save.GiftAmount'])}</Label>
        <Col
          className={classNames({ 'align-items-center': readOnly, 'd-flex': readOnly })}
          sm={8}>
          <div className="d-flex">
            <If condition={readOnly}>
              <Then>{() => <>{displayValue}</>}</Then>
              <Else>
                {() => (
                  <>
                    <div className="align-items-start d-flex flex-column flex-grow-1">
                      <StartDate />
                    </div>
                    <div className="align-items-center d-flex mx-2">{s('Site.To', { casing: 'lowercase' })}</div>
                    <div className="align-items-start d-flex flex-column flex-grow-1">
                      <EndDate />
                    </div>
                  </>
                )}
              </Else>
            </If>
          </div>
        </Col>
      </FormGroup>
      <If condition={!isActive && datesChanged}>
        <Then>
          {() => (
            <Col sm={{ offset: 4, size: 8 }}>
              <div className="mt-1">
                <Alert type="warning">{s(['Site.Pages.AudienceBuilder.Dashboard.Messages.Process.GiftDate'])}</Alert>
              </div>
            </Col>
          )}
        </Then>
      </If>
    </>
  );
};

export default GiftAmount;
